import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { stats, heroImage } from '../mock';

const Hero = () => {
  return (
    <section id="home" className="relative overflow-hidden pt-[70px]">
      {/* Background image + gradient overlay */}
      <div className="absolute inset-0">
        <img src={heroImage} alt="IT support team" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-800/95 via-blue-700/90 to-blue-900/95" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-24 md:py-32">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block animate-fade-up bg-cyan-400/20 border border-cyan-300/40 text-cyan-100 text-sm font-medium px-4 py-1.5 rounded-full backdrop-blur-sm">
            Trusted by 5,000+ businesses nationwide
          </span>

          <h1 className="animate-fade-up mt-7 font-heading font-extrabold text-white text-4xl md:text-6xl leading-[1.1]" style={{ animationDelay: '0.05s' }}>
            Expert Computer Support
            <span className="block text-cyan-300 mt-2">When You Need It Most</span>
          </h1>

          <p className="animate-fade-up mt-6 text-blue-100 text-lg md:text-xl leading-relaxed max-w-2xl mx-auto" style={{ animationDelay: '0.1s' }}>
            Professional technical support for all brands, software, and antivirus solutions. Get your tech working flawlessly with our expert team.
          </p>

          <div className="animate-fade-up mt-9 flex flex-col sm:flex-row items-center justify-center gap-4" style={{ animationDelay: '0.15s' }}>
            <Button asChild size="lg" className="bg-cyan-500 hover:bg-cyan-400 text-slate-900 font-semibold rounded-lg px-7 h-12 text-base shadow-lg shadow-cyan-500/30">
              <a href="#contact">Get Started Today <ArrowRight size={18} className="ml-1" /></a>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-white/40 bg-white/5 text-white hover:bg-white/15 hover:text-white rounded-lg px-7 h-12 text-base backdrop-blur-sm">
              <a href="#support">View Services</a>
            </Button>
          </div>
        </div>

        {/* Stats */}
        <div className="animate-fade-up mt-16 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto" style={{ animationDelay: '0.2s' }}>
          {stats.map((s) => (
            <div key={s.label} className="bg-white/10 border border-white/15 rounded-xl px-5 py-6 text-center backdrop-blur-sm hover:bg-white/15 transition-colors">
              <div className="font-heading font-bold text-cyan-300 text-3xl md:text-4xl">{s.value}</div>
              <div className="text-blue-100 text-sm mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
